import { render } from "./PermissionModal.vue?vue&type=template&id=51179f9a&ts=true"
import script from "./PermissionModal.vue?vue&type=script&lang=ts"
export * from "./PermissionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__